// Both picker and drop accept exactly one PDF. Invalid input preserves the current selection.
export function singlePassportPdf(files: File[]): File | null {
  return files.length === 1 && (files[0].type === "application/pdf" || files[0].name.toLowerCase().endsWith(".pdf")) ? files[0] : null;
}
